// removed by extract-text-webpack-plugin
module.exports = {"card":"styles__card___3sIK4","name":"styles__name___2bgpw","icon":"styles__icon___RP4Ff"};


//////////////////
// WEBPACK FOOTER
// ./src/views/search/tasks-card/styles.css
// module id = 1143
// module chunks = 0